import {Component,
  OnInit,
  Input,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  Injector,
  SimpleChange,
  AfterContentInit,
  AfterViewInit,
  NgModule,
  Inject,
  PLATFORM_ID,
  ChangeDetectorRef, OnDestroy} from '@angular/core';
import {catchError, debounceTime, distinctUntilKeyChanged, finalize, first, map, takeWhile} from 'rxjs/operators';
import {Router, NavigationStart, RouterModule, NavigationEnd} from '@angular/router';
import {Observable, of, Subscription, timer} from 'rxjs';
import * as firebase from 'firebase/app';
import {countryConfig as _countryConfig } from 'src/country-config/country-config';
import {CommonModule, isPlatformBrowser} from '@angular/common';
import {GoogleTagService} from 'src/app/data/networking/services/shared/google-tag/google-tag.service';
import {AngularFireDatabase} from '@angular/fire/database';
import {Select} from '@ngxs/store';
import {ImageTextSimpleModalModule} from 'src/app/ui/modals/image-text-simple-modal/image-text-simple-modal.component';
import {SessionEvent} from '../../../event-listeners/session/session.event';
import {NavBarVm} from '../../../../../view-model/nav-bar/nav-bar.vm';
import {UpdateCartEvent} from '../../../event-listeners/update-cart/update-cart.event';
import {UpdateAddressEvent} from '../../../event-listeners/update-address/update-address.event';
import {ResizeEvent} from '../../../event-listeners/resize/resize.event';
import {UpdateSasCartEvent} from '../../../event-listeners/update-sas-cart/update-sas-cart.event';
import {UpdateCustomerEvent} from '../../../event-listeners/update-customer/update-customer.event';
import {UpdateSessionModalEvent} from '../../../event-listeners/update-session-modal/update-session-modal.event';
import {CustomerProfileMenuEvent} from '../../../event-listeners/customer-profile-menu/customer-profile-menu.event';
import {UpdateLocationEvent} from '../../../event-listeners/update-location/update-location.event';
import {EnableLifeMilesEvent} from '../../../event-listeners/enable-life-miles/enable-life-miles.event';
import 'firebase/remote-config';

import {AlgoliaSearchBoxModule} from '../../algolia-search-box/algolia-search-box.module';
import {LoadingModule} from '../../loading/loading.module';
import {DeliveryTypeComponent} from '../delivery-type/delivery-type.component';
import {AddressUserComponent} from '../address-user/address-user.component';
import {CartComponent} from '../cart/cart.component';
import {IconsModule} from '../../icons/icons.module';
import {ButtonModule} from '../../button/button.module';
import {CopCurrencyModule} from '../../../pipes/cop-currency/cop-currency.module';
import {PageEvent} from '../../../event-listeners/event-page/event-page.event';
import {CountryConfigEvent} from '../../../event-listeners/country-config-event/country-config-event';
import {MultiCountryCurrencyModule} from '../../../pipes/multi-country-currency/multi-country-currency.module';
import {CountryComponent} from '../country/country.component';
import {DepartmentsHeaderModule} from '../departments/departments.module';
import {UpdateNavbarEvent} from '../../../event-listeners/update-navbar/update-navbar.event';
import {UpdateCreatePasswordModalEvent} from '../../../event-listeners/update-create-password-modal/update-create-password-modal.event';
import {AddressSelectModule} from '../../address-select/address-select.module';
import {MobileConnectorService} from 'src/app/data/networking/services/shared/mobile-connector/mobile-connector.service';
import {ShowSelectAddressEvent} from '../../../event-listeners/show-select-address/show-select-address.event';
import {UpdateNotificationModalEvent} from '../../../event-listeners/update-notification-modal/update-notification-modal.event';
import {AdvertisedProductsEvent} from '../../../event-listeners/advertised-products/advertised-products.event';
import {AdvertisedProductsModule} from 'src/app/ui/modals/advertised-products/advertised-products.module';
import {UpdateCreateCreditCardModalEvent} from '../../../event-listeners/update-create-credit-card-modal/update-create-credit-card-modal.event';
import {PrimeEvent} from '../../../event-listeners/prime/prime.event';
import {SessionStorageManager} from 'src/app/data/manager/session-storage/session-storage.manager';
import {MicroChangesEvent} from '../../../event-listeners/micro-changes/micro-changes.event';
import {AppState} from 'src/app/app.reducer';
import {PrModalsEvent} from '../../../event-listeners/pr-modals/pr-modals.event';
import {HeaderModule} from '../../header/header.component';
import *  as Ngrx from '@ngrx/store';
import * as actions from 'src/app/data/actions/addresses-modal.actions';
import {NotificationIndicatorComponent} from '../notifications-indicator/notification-indicator.component';

const fbDataBase = 'https://stunning-base-delivery-tracking.firebaseio.com/';
const fbDBPath = `server/order/${_countryConfig.navbar.tracking}/`;
export let browserRefresh = false;
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit, AfterContentInit, AfterViewInit, OnDestroy {
  @ViewChild('customModalVip', { read: ViewContainerRef }) customModalVip: ViewContainerRef;
  @ViewChild('policiesModal', { read: ViewContainerRef }) policiesModal: ViewContainerRef;
  @ViewChild('couponModal', { read: ViewContainerRef }) couponModal: ViewContainerRef;
  @ViewChild('creditCardModal', { read: ViewContainerRef }) creditCardModal: ViewContainerRef;
  @ViewChild('microCharges', { read: ViewContainerRef }) microCharges: ViewContainerRef;
  @ViewChild('itemQuantityAlert', { read: ViewContainerRef }) itemQuantityAlert: ViewContainerRef;
  @ViewChild('takePillModal', { read: ViewContainerRef }) takePillModal: ViewContainerRef;
  @ViewChild('popupModal', { read: ViewContainerRef }) popupModal: ViewContainerRef;
  @ViewChild('creditCardFormModal', { read: ViewContainerRef }) creditCardFormModal: ViewContainerRef;
  @ViewChild('sessionModal', { read: ViewContainerRef }) sessionModal: ViewContainerRef;
  @ViewChild('lifeMilesModal', { read: ViewContainerRef }) lifeMilesModal: ViewContainerRef;
  @ViewChild('contactsModal', { read: ViewContainerRef }) contactsModal: ViewContainerRef;
  @ViewChild('qualifyModal', { read: ViewContainerRef }) qualifyModal: ViewContainerRef;
  @ViewChild('addressesModal', { read: ViewContainerRef }) addressesModal: ViewContainerRef;
  @ViewChild('deleteSasCartModal', { read: ViewContainerRef }) deleteSasCartModal: ViewContainerRef;
  @ViewChild('profileMenu', { read: ViewContainerRef }) profileMenu: ViewContainerRef;
  @ViewChild('cancelOrderModal', { read: ViewContainerRef }) cancelOrderModal: ViewContainerRef;
  @ViewChild('supportModal', { read: ViewContainerRef }) supportModal: ViewContainerRef;
  @ViewChild('createPasswordModal', { read: ViewContainerRef }) createPasswordModal: ViewContainerRef;
  @ViewChild('changePasswordComponent', { read: ViewContainerRef }) changePasswordComponent: ViewContainerRef;
  @ViewChild('addEditAddressesModal', { read: ViewContainerRef }) addEditAddressesModal: ViewContainerRef;
  @ViewChild('sasSidebarCart', { read: ViewContainerRef }) sasSidebarCart: ViewContainerRef;
  @ViewChild('sasProductNotAvailable', { read: ViewContainerRef }) sasProductNotAvailable: ViewContainerRef;
  @ViewChild('p2cHomebar', { read: ViewContainerRef }) p2cHomebar: ViewContainerRef;
  @ViewChild('advertisedProducts', { read: ViewContainerRef }) advertisedProductsModal: ViewContainerRef;
  @ViewChild('primeNotAvailable', { read: ViewContainerRef }) primeNotAvailableModal: ViewContainerRef;

  @Select(state => state.scanAndGoStore) scanAndGoStore$: Observable<any>;
  @Input() colorNav;
  countryConfig = _countryConfig;
  showAppBar = false;
  scanAndGoStore;
  customerNav;
  screenSize;
  showMenu = false;
  addresses;
  cart;
  sasCart;
  customer;
  anyCustomer;
  showCitiesMobile = false;
  loadModals;
  routerHome = false;
  web;
  disableSas = !!this.countryConfig.general.disableSas;
  loadNavBar = false;
  webWorker: Worker;
  timerWebWorker: Worker;
  callCenterCustomer;
  loadMenu = false;
  loadOptions = false;
  loadAddressesModal = false;
  enableLifeMiles;
  vipModalInstance;
  addEditAddressesModalInstance;
  profileCount = 0;
  configModule: any;
  isBrowser;
  responsiveMenuInstance;
  refChange;
  dbRef;
  logo;
  bgImage;
  activeCustom =false;
  showBgImage: boolean = true;
  changeDeliveryAlert = {
    text: 'Al cambiar la ciudad o tipo de envío, puede variar la disponibilidad de los productos',
    img: '/assets/svg/prodcuts-change-delivery.svg',
  };
  performanceComponents = true;
  disableSasCart = true;
  loadNavBarUser = true;
  public christmas: boolean = this.countryConfig.christmas;
  public setHeaderStyle = null;
  setHEaderSubscriber: Subscription;
  advertisedModal = {open: false};
  advertisedProducts = [];
  setColorHome;
  gender:string;
  addressModal;
  configStylesHeader;
  callGetAddress = true;

  constructor(
    private loginEvent: SessionEvent,
    private vm: NavBarVm,
    private addressEvent: UpdateAddressEvent,
    private resizeEvent: ResizeEvent,
    private updateAgileCartEvent: UpdateCartEvent,
    private updateSasCartEvent: UpdateSasCartEvent,
    private gtmService: GoogleTagService,
    private updateCustomerEvent: UpdateCustomerEvent,
    private sessionModalStatusEvent: UpdateSessionModalEvent,
    private router: Router,
    private menuEvent: CustomerProfileMenuEvent,
    private updateLocationEvent: UpdateLocationEvent,
    private enableLifeMilesEvent: EnableLifeMilesEvent,
    private cfr: ComponentFactoryResolver,
    private injector: Injector,
    private configCountry: CountryConfigEvent,
    private eventPage: PageEvent,
    private rtdb: AngularFireDatabase,
    private updateNavbarEvent: UpdateNavbarEvent,
    private detector: ChangeDetectorRef,
    private store: Ngrx.Store<AppState>,
    private storeNgrx: Ngrx.Store<AppState>,
    @Inject(PLATFORM_ID) platformId,
    private eventModalCreatePassword: UpdateCreatePasswordModalEvent,
    private mcs: MobileConnectorService,
    private showSelectAddressEvent: ShowSelectAddressEvent,
    private notificationModalEvent: UpdateNotificationModalEvent,
    private advertisedProd: AdvertisedProductsEvent,
    private createCreditCardModalEvent: UpdateCreateCreditCardModalEvent,
    private primeEvent: PrimeEvent,
    private ssm: SessionStorageManager,
    private microChangesEvent: MicroChangesEvent,
    private prModalsEvent: PrModalsEvent,
  ) {
    this.isBrowser = isPlatformBrowser(platformId) && !(navigator?.userAgent.indexOf('Chrome-Lighthouse') > -1);
    if (this.isBrowser) {
      this.web = window.screen.width >= 992;
      this.logo = (this.web) ? '/assets/svg/logo-farmatodo.svg' : '/assets/svg/logo-farmatodo-blue.svg';
      this.screenSize = {
        desktop: window.screen.width >= 992,
        mobile: window.screen.width < 992,
        cartMobile: window.screen.width >= 768,
      };
      this.valideLogo(false);
      this.configCountry.getCountryConfig.subscribe((config: any) => {
        if (config.general) {
          this.configModule = config.general;
        }
      });

      this.vm.getSetColorsHeaderAlgoliaCustoms( 'WEB.HEADER.CONFIG.DEV' );
      this.vm.getSetColorsHeaderAlgolia( 'WEB.HEADER.CONFIG' );
      this.getHeaderConfiguration();
  }
  
    this.advertisedProd.advertisedProducts.subscribe(res => {
      if(res.length > 0){
        this.advertisedModal = {open: true};
        this.advertisedProducts = res;
        this.getAdvertisedModal(this.advertisedProducts, { open: true });
        //this.getPrimeNotAvailableModal({ open: true });
      }
    });
    this.store.select('addressModal', 'openModal').subscribe(
      (state) => this.addressModal = state
    );
  }

  getHeaderConfiguration(){
    this.setHEaderSubscriber = this.storeNgrx.select( 'setHeader' ).subscribe(  (data: any) => {
      this.setHeaderStyle = data?.data;
      if((data?.dataCustom?.activeMen || data?.dataCustom?.activeWomen)){
        if(this.gender === 'M' &&  data?.dataCustom?.activeMen){
          this.activeCustom = data?.dataCustom?.activeMen;
          this.bgImageHeader(data?.dataCustom?.configMen);
          this.configStylesHeader = data?.dataCustom?.configMen;
        }else if(this.gender === 'F' &&  data?.dataCustom?.activeWomen){
          this.activeCustom = data?.dataCustom?.activeWomen;
          this.bgImageHeader(data?.dataCustom?.configWomen);
          this.configStylesHeader = data?.dataCustom?.configWomen;
        }else if(data?.data?.active){
          this.bgImageHeader(data?.data?.config);
          this.configStylesHeader = data?.data?.config;
        }
      }
      else if(data?.data?.active){
        this.bgImageHeader(data?.data?.config);
        this.configStylesHeader = data?.data?.config;
      }
      if(this.configStylesHeader && !this.configStylesHeader?.header_notification_icon) {
        this.configStylesHeader.header_notification_icon = '/assets/svg/white-bell.png';
      }
  })
  }

  bgImageHeader(config){
    if((this.setHeaderStyle?.active || this.activeCustom) && config?.header_background_img && !this.screenSize.mobile){         
        this.bgImage = `url(${config?.header_background_img})`;        
      }
      else if((this.setHeaderStyle?.active || this.activeCustom) && config?.header_background_img_mobile && this.screenSize.mobile){          
        this.bgImage = `url(${config?.header_background_img_mobile})`;
      }
  }

  async getPrimeNotAvailableModal(modalStatus) {
    if (this.primeNotAvailableModal) {
      this.primeNotAvailableModal.clear();
      const { PrimeNotAvailableComponent } = await import('../../../../modals/prime-not-available/prime-not-available.component');
      const factory = this.cfr.resolveComponentFactory(PrimeNotAvailableComponent);
      const { instance } = this.primeNotAvailableModal.createComponent(factory, null, this.injector);
      instance.modalStatus = modalStatus;
    }
  }

  async getAdvertisedModal(products, modalStatus) {
    if (this.advertisedProductsModal) {
      this.advertisedProductsModal.clear();
      const { AdvertisedProductsComponent } = await import('../../../../modals/advertised-products/advertised-products.component');
      const factory = this.cfr.resolveComponentFactory(AdvertisedProductsComponent);
      const { instance } = this.advertisedProductsModal.createComponent(factory, null, this.injector);
      instance.products = products;
      instance.modalStatus = modalStatus;
    }
  }


  onLogin() {
    this.loginEvent.currentLoginStatus
      .pipe(debounceTime(500))
      .subscribe(status => {
        this.loadNavBar = false;
        if (status) {
          this.customer = this.vm.getCustomer();
          this.onCustomer();
          this.getHeaderConfiguration();
          this.onCustomer();
          this.getAgile();
          this.vm
            .getSasCart()
            .pipe(first())
            .subscribe();
          this.getFavorites();
          this.clearPrimeUser( 'primeSubscription' );
          this.getSubscriptionPlan();
          this.validateOrders();
          if (this.callGetAddress) {
            this.getAddressUser();
          }
        }
      });
  }

  showNotificationIcon() {
    return this.isBrowser && !(navigator?.userAgent.indexOf('Chrome-Lighthouse') !== -1);
  }

  getSubscriptionPlan(){
    this.primeEvent.changePrimePlan( { update: true } );
  }

  valideLogo(deparment) {
    if (deparment) {
      this.logo = '/assets/svg/logo-farmatodo-blue.svg';
      return;
    }
    this.logo = '/assets/svg/logo-farmatodo-blue.svg';
  }

  menuOptions(option) {
    this.showCitiesMobile = undefined;
    if (option.option) {
      switch (option.option) {
        case 'changeCity':
          this.showCitiesMobile = option.value;
          break;
        case 'coupon':
          if (option.type === 'link') {
            this.router.navigate([option.value]);
          } else {
            this.getCoupon(option.value);
          }
          break;
        case 'contacts':
          this.getContactsModal(option.value);
          break;
        case 'changePassword':
          this.getChangePasswordModal(option.value);
          break;
        case 'currentOrderVerify':
          this.currentOrderVerify(option.value);
          break;
        case 'creditCard':
          this.getCreditCard(option.value, option.from);
          this.getCreditCardForm();
          break;
        case 'lifeMiles':
          if (option.type === 'link') {
            this.router.navigate([option.value]);
          } else {
            this.getLifeMiles(option.value);
          }
          break;
        case 'logOut':
          this.logOut();
          break;
        case 'orders':
          this.router.navigate([option.value]);
          break;
        case 'legal':
          if (option.type === 'link') {
            this.router.navigate([option.value]);
          } else {
            this.getPolicies(option.value);
          }
          break;
        case 'profile':
          this.router.navigate([option.value]);
          break;
        case 'session':
          this.openSessionModal();
          break;
        case 'notifications':
          this.openNotificationsModal();
          break;
        case 'sas':
          this.router.navigate([option.value]);
          break;
        case 'stores':
          this.router.navigate([option.value]);
          break;
        case 'cancelOrder':
          this.openCancelOrderModal(option.value);
          break;
        case 'supportModal':
          this.openSupportModal(option.value);
          break;
        default:
          this.router.navigate([option.value]);
          break;
      }
    }
  }

  onMenuOption(option) {
    this.menuOptions(option);
  }

  goToHome() {
    if (this.isBrowser) {
      window.location.href = window.location.origin;
    }
  }

  eventColorNavbarBrand() {
    this.updateNavbarEvent.updatedColorNavbar.subscribe(res => {
      if (res !== null && res?.toolbarBackground) {
        this.colorNav = this.vm.getNavBarColor('navColor') ? this.vm.getNavBarColor('navColor') : res.toolbarBackground;
      }
    });
  }

  listenEmiterCoupon(event) {
    if (this.customer) {
      this.getCoupon(event);
    } else {
      this.openSessionModal();
    }
  }

  listenEmiterColor(event) {
    this.colorNav = event;
  }

  logOut() {
    const device = this.mcs.device;
    this.vm
      .logOut()
      .pipe(
        finalize(() => {
          if (this.isBrowser) {
            this.mcs.setDevice(device);
            window.location.href = '/';
          }
        }),
      )
      .subscribe();
  }

  getAgileEvent() {
    this.vm
      .getCart()
      .pipe(first())
      .subscribe(cart => {
        this.cart = cart;
      });
  }

  getAgile(force?) {
    this.vm
      .getAgileCart(force)
      .subscribe(cart => {
        this.cart = cart;
      });
  }

  onAgileCartUpdated() {
    this.updateAgileCartEvent.updatedAgileCart
      .subscribe(cart => {
        const cartUpdate = {...this.cart,...cart};
        this.gtmService.agileCartUpdated(cartUpdate);
        this.cart = cartUpdate;
      });
  }

  onSasCartUpdated() {
    this.updateSasCartEvent.updatedSasCart
      .subscribe(cart => {
        this.sasCart = cart;
      });
  }

  openAddressModal() {
    this.callCenterCustomer = this.vm.callCenterCustomer();
    if (this.callCenterCustomer) {
      this.addresses = this.callCenterCustomer.addresses;
    }
    if (this.customer) {
      this.store.dispatch(actions.addAfterEdit());
      this.store.dispatch(actions.openModal({open: true}));
    }
  }

  openSessionModal() {
    if (!this.loadNavBar) {
      this.getSessionModal({open: true});
    }
  }

  openNotificationsModal(){
    if (!this.loadNavBar) {
      this.getNotificationsModal({open: true});
    }
  }

  getAddresses(force = false) {
    if (force || !this.addresses) {
      this.addresses = null;
      this.vm
        .getAddresses()
        .pipe(
          debounceTime(1000),
          takeWhile(() => !this.addresses)
        )
        .subscribe(addresses => {
          this.addresses = addresses;
        });
    }
  }

  get hasOpenSession(){
    return this.customer?.customerId;
  }

  hasCustomer() {
    this.vm.hasCustomer().subscribe(customer => {
      if(customer?.customerId){
        this.gender = 'anonimo'
      }else{
        if(customer?.customer?.gender){
          this.gender = customer?.customer?.gender
        }
        else{
          this.customer && this.vm.getGender(customer?.customer?.analyticsUUID).subscribe(res =>{
            this.gender= res?.users[0]?.gender;
           })
        }
      }
      
      if (customer && customer.status) {
        this.anyCustomer = customer;
        if (customer.customerId) {
          this.customer = customer;
          this.onCustomer();
        }
      }

      if (customer === true) {
        this.getFavorites();
      }
    });
  }

  onUpdateCustomer() {
    this.updateCustomerEvent.updatedCustomer.subscribe(customer => {
      if (customer !== null) {
        this.customer = customer;
        this.onCustomer();
      }
      else if (customer) {
        this.anyCustomer = customer;
      }
    });
  }

  getCustomer() {
    this.vm
      .getValidCustomer()
      .pipe(first())
      .subscribe(c => {
        if (c) {
          this.customer = c;
          this.onCustomer();
        }
        this.loadNavBar = false;
      }, error => {
        this.vm.getUserOrigin(this.customer?.customer).subscribe(res => {
          if(res?.statusCode === 204) {
            this.logOut();
          }
        })
      });
  }

  onUpdateDeliveryType() {
    this.updateLocationEvent.updatedDeliveryType.subscribe(() => {
      this.disableSas = !this.vm.isSasEnabled();

      if (this.responsiveMenuInstance) {
        this.responsiveMenuInstance.ngOnChanges({disableSas: new SimpleChange(null, this.disableSas, false)});
      }
    });
  }

  onOpenSasConfirmation(event) {
    this.getDeleteSasCartModal(event);
  }

  onCartUpdated() {
    this.updateAgileCartEvent.updatedCart.subscribe(event => {
      if (event) {
        if (event?.totalPrice) {
          this.cart = event;
        } else {
          this.getAgile(true);
        }
      }
      else {
        this.getAgile(true);
      }
    });
  }

  onEnableLifeMilesEvent() {
    this.enableLifeMilesEvent.status.subscribe(status => {
      this.enableLifeMiles = status;
    });
  }

  onCallCenterLogin() {
    this.loginEvent.callCenterLoginStatus
      .subscribe(data => {
        this.callCenterCustomer = data;
      });
  }

  onCallCenterLogOut(event) {
    if (event) {
      this.vm.callCenterLogOut().subscribe();
    }
  }

  manageEvent() {
    if (!this.callCenterCustomer) {
      this.openAddressModal();
    }
  }

  onCustomer() {
    timer(300)
      .pipe(debounceTime(300))
      .subscribe(() => {
        if (this.vipModalInstance && this.customer) {
          this.vipModalInstance.ngOnChanges({
            customer: new SimpleChange(null, this.customer, false),
          });
        }
        if (!this.screenSize?.mobile) {
          this.getProfileMenu();
        }
      }
      );
  }

  currentOrderVerify(order: any) {
    if (this.dbRef && this.refChange) { this.dbRef.off('value', this.refChange); }
    this.dbRef = this.rtdb.database.app.database(fbDataBase).ref(`${fbDBPath}${order.orderId}/status`);
    this.refChange = this.dbRef.on('value', (res: any) => {
      const status = res.val();
      if (status === 'order_finalized') {
        this.dbRef.off('value', this.refChange);
      }
      this.detector.detectChanges();
    });
  }

  async getCustomModal() {
    if (this.customModalVip && !document.querySelector('app-custom-modal .vip')) {
      this.customModalVip.clear();
      const {CustomModalComponent} = await import('../../../../modals/custom-modal/custom-modal.component');
      const factory = this.cfr.resolveComponentFactory(CustomModalComponent);
      const {instance} = this.customModalVip.createComponent(factory, null, this.injector);
      this.vipModalInstance = instance;
      instance.vip = true;
      instance.customer = this.customer;
    }
  }

  async getPolicies(value) {
    if (this.policiesModal) {
      this.policiesModal.clear();
      const {PrivacyPoliciesComponent} = await import('../../../../modals/privacy-policies/privacy-policies.component');
      const factory = this.cfr.resolveComponentFactory(PrivacyPoliciesComponent);
      const {instance} = this.policiesModal.createComponent(factory, null, this.injector);
      setTimeout(() => {
        instance.privacyModalStatus = value;
      }, 10);
    }
  }

  async getCoupon(value) {
    if (this.couponModal) {
      this.couponModal.clear();
      const {CuponComponent} = await import('../../../../modals/cupon/cupon.component');
      const factory = this.cfr.resolveComponentFactory(CuponComponent);
      const {instance} = this.couponModal.createComponent(factory, null, this.injector);
      setTimeout(() => {
        instance.cuponModalStatus = value;
      }, 50);
    }
  }

  async getCreditCard(value, from?) {
    if (this.creditCardModal) {
      this.creditCardModal.clear();
      const {CreditCardComponent} = await import('../../../../modals/credit-card/credit-card.component');
      const factory = this.cfr.resolveComponentFactory(CreditCardComponent);
      const {instance} = this.creditCardModal.createComponent(factory, null, this.injector);
      setTimeout(() => {
        if (from === 'prime' && value?.open === true) {
          instance.modalChangeTcPrime = {open: true, close: false};
          instance.creditCardModalStatus = {open: false, close: true};
        } else {
          instance.creditCardModalStatus = value;
        }
        if(from){
          instance.openFrom = from;
        }
      }, 100);
    }
  }

  async getMicroCharges(value) {
    if (this.microCharges && value.length > 1) {
      this.microCharges.clear();
      const {CreditCardVerificationComponent} = await import('../../../../modals/credit-card-verification/credit-card-verification.component');
      const factory = this.cfr.resolveComponentFactory(CreditCardVerificationComponent);
      const {instance} = this.microCharges.createComponent(factory, null, this.injector);
        instance.microChargesState = value[0];
        instance.creditCardId = value[1]?.credit;
        instance.tokenization = value[2]?.tokenization;
    }
  }

  async getItemQuantityAlert() {
    if(this.itemQuantityAlert) {
      this.itemQuantityAlert.clear();
      const {ItemQuantityAlertComponent} = await import('../../../../modals/item-quantity-alert/item-quantity-alert.component');
      const factory = this.cfr.resolveComponentFactory(ItemQuantityAlertComponent);
      const {instance} = this.itemQuantityAlert.createComponent(factory, null, this.injector);
      instance.statusModal = { open: true, close: false };
    }
  }

  async getTakePillModal() {
    if(this.takePillModal) {
      this.takePillModal.clear();
      const {TakePillModalComponent} = await import('../../../../modals/take-pill-modal/take-pill-modal.component');
      const factory = this.cfr.resolveComponentFactory(TakePillModalComponent);
      const {instance} = this.takePillModal.createComponent(factory, null, this.injector);
      instance.statusModal = { open: true, close: false };
    }
  }

  async getPopupModal() {
    if(this.popupModal) {
      this.popupModal.clear();
      const {PillReminderModalComponent} = await import('../../../../modals/pill-reminder/pill-reminder-modal.component');
      const factory = this.cfr.resolveComponentFactory(PillReminderModalComponent);
      const {instance} = this.popupModal.createComponent(factory, null, this.injector);
      instance.itemsToSearch = this.prModalsEvent.products;
      instance.modalStatus = { open: true, close: false };
    }
  }

  async getCreditCardForm() {
    if (this.creditCardFormModal) {
      this.creditCardFormModal.clear();
      const {CreditCardFormComponent} = await import('../../../../modals/credit-card-form/credit-card-form.component');
      const factory = this.cfr.resolveComponentFactory(CreditCardFormComponent);
      const {instance} = this.creditCardFormModal.createComponent(factory, null, this.injector);
      setTimeout(() => {
        instance.modalStatus = {close: true};
      }, 100);
    }
  }

  async getSessionModal(value) {
    if (this.sessionModal) {
      this.sessionModal.clear();
      const {SessionModalComponent} = await import('../../../../modals/session-modal/session-modal.component');
      const factory = this.cfr.resolveComponentFactory(SessionModalComponent);
      const {instance} = this.sessionModal.createComponent(factory, null, this.injector);
      setTimeout(() => {
        instance.modalStatus = value;
      }, 50);
    }
  }

  async getNotificationsModal(value) {
    if (this.sessionModal) {
      this.sessionModal.clear();
      const {NotificationsComponent} = await import('../../../../modals/notifications/notifications.component');
      const factory = this.cfr.resolveComponentFactory(NotificationsComponent);
      const {instance} = this.sessionModal.createComponent(factory, null, this.injector);
      setTimeout(() => {
        instance.modalStatus = value;
      }, 50);
    }
  }


  async getRegisterModal(value) {
    if (this.sessionModal) {
      this.sessionModal.clear();
      const {SessionModalComponent} = await import('../../../../modals/session-modal/session-modal.component');
      const factory = this.cfr.resolveComponentFactory(SessionModalComponent);
      const {instance} = this.sessionModal.createComponent(factory, null, this.injector);
      setTimeout(() => {
        instance.modalStatus = value;
        instance.isRegister = true;
      }, 50);
    }
  }

  async getLifeMiles(value) {
    if (this.lifeMilesModal) {
      this.lifeMilesModal.clear();
      const {LifemilesComponent} = await import('../../../../modals/lifemiles/lifemiles.component');
      const factory = this.cfr.resolveComponentFactory(LifemilesComponent);
      const {instance} = this.lifeMilesModal.createComponent(factory, null, this.injector);
      setTimeout(() => {
        instance.lifemilesModalStatus = value;
      }, 50);
    }
  }

  async getContactsModal(value) {
    if (this.contactsModal) {
      this.contactsModal.clear();
      const {ContactComponent} = await import('../../../../modals/contact/contact.component');
      const factory = this.cfr.resolveComponentFactory(ContactComponent);
      const {instance} = this.contactsModal.createComponent(factory, null, this.injector);
      setTimeout(() => {
        instance.contactModalStatus = value;
      }, 50);
    }
  }

  async getChangePasswordModal(value) {
    if (this.changePasswordComponent) {
      this.changePasswordComponent.clear();
      const {ChangePasswordComponent} = await import('../../../../modals/change-password/change-password.component');
      const factory = this.cfr.resolveComponentFactory(ChangePasswordComponent);

      const {instance} = this.changePasswordComponent.createComponent(factory, null, this.injector);
      setTimeout(() => {
        instance.modalStatus = value;
      }, 50);
    }
  }

  async getQualifyModal(value) {
    if (this.qualifyModal) {
      this.qualifyModal.clear();
      const {QualifyOrderModalComponent} = await import('../../../../modals/qualify-order/qualify-order.component');
      const factory = this.cfr.resolveComponentFactory(QualifyOrderModalComponent);
      const {instance} = this.qualifyModal.createComponent(factory, null, this.injector);
      setTimeout(() => {
        instance.qualifyOrderModalStatus = value.status;
        instance.ratingSendObj = value.orderId;
      }, 50);
    }
  }

  async getAddEditAddressesModal(data) {
    const updateInstance = (i, value) => {
      timer(500)
        .pipe(first())
        .subscribe(() => {
          i.ngOnChanges({modalData: new SimpleChange(null, value, false)});
        });
    };

    if (this.addEditAddressesModal && !this.addEditAddressesModalInstance) {
      this.addEditAddressesModal.clear();
      let factory;
      if (this.countryConfig.navbar.modalAddressOne) {
        const {AddEditAddressComponent} = await import('../../../../modals/add-edit-address/add-edit-address.component');
        factory = this.cfr.resolveComponentFactory(AddEditAddressComponent);
      } else {
        const {EditAddressLiteComponent} = await import('../../../../modals/edit-address-lite/edit-address-lite.component');
        factory = this.cfr.resolveComponentFactory(EditAddressLiteComponent);
      }
      const {instance} = this.addEditAddressesModal.createComponent(factory, null, this.injector);
      updateInstance(instance, data);
      this.addEditAddressesModalInstance = instance;
    } else if (this.addEditAddressesModalInstance) {
      updateInstance(this.addEditAddressesModalInstance, data);
    }
  }

  async getAddressesModal(data) {
    if (this.addressesModal) {
      const {status, sasCart, addresses} = data;
      this.addressesModal.clear();
      const {AddressesComponent} = await import('../../../../modals/addresses/addresses.component');
      const factory = this.cfr.resolveComponentFactory(AddressesComponent);
      const {instance} = this.addressesModal.createComponent(factory, null, this.injector);
      instance.sasCart = sasCart;
      instance.addresses = addresses;
      instance.openSasConfirmation.subscribe(event => {
        this.onOpenSasConfirmation(event);
      });
      setTimeout(() => {
        instance.status = status;
        (instance as any).ngOnChanges({
          status: new SimpleChange(null, status, false),
        });
      }, 50);
    }
  }

  async getDeleteSasCartModal(value) {
    if (this.deleteSasCartModal) {
      this.deleteSasCartModal.clear();
      const {DeleteSasCartComponent} = await import('../../../../modals/delete-sas-cart/delete-sas-cart.component');
      const factory = this.cfr.resolveComponentFactory(DeleteSasCartComponent);
      const {instance} = this.deleteSasCartModal.createComponent(factory, null, this.injector);
      setTimeout(() => {
        instance.modalData = value;
        (instance as any).ngOnChanges({
          modalData: new SimpleChange(null, value, false),
        });
      }, 50);
    }
  }

  async getProfileMenu() {
    if (this.profileMenu) {
      const {ProfileComponent} = await import('../profile/profile.component');
      this.profileMenu.clear();
      const factory = this.cfr.resolveComponentFactory(ProfileComponent);
      const {instance} = this.profileMenu.createComponent(factory, null, this.injector);
      instance.customer = this.customer;
      instance.enableLifeMiles = this.enableLifeMiles;
      instance.menuOption.subscribe(event => {
        this.onMenuOption(event);
      });
      this.loadNavBarUser = false;
    }
  }

  async openCancelOrderModal(value) {
    if (this.cancelOrderModal) {
      this.cancelOrderModal.clear();
      const {CancelOrderComponent} = await import('../../../../modals/cancel-order/cancel-order.component');
      const factory = this.cfr.resolveComponentFactory(CancelOrderComponent);
      const {instance} = this.cancelOrderModal.createComponent(factory, null, this.injector);
      setTimeout(() => {
        instance.modalStatus = value;
      }, 50);
    }
  }

  async openSupportModal(value) {
    if (this.supportModal) {
      this.supportModal.clear();
      const {SupportModalComponent} = await import('../../../../modals/support-modal/support-modal.component');
      const factory = this.cfr.resolveComponentFactory(SupportModalComponent);
      const {instance} = this.supportModal.createComponent(factory, null, this.injector);
      setTimeout(() => {
        instance.modalStatus = value;
      }, 50);
    }
  }

  async getCreatePasswordModal(value) {
    if (this.createPasswordModal) {
      this.createPasswordModal.clear();
      const {CreatePasswordComponent} = await import('../../../../modals/create-password/create-password.component');
      const factory = this.cfr.resolveComponentFactory(CreatePasswordComponent);
      const {instance} = this.createPasswordModal.createComponent(factory, null, this.injector);
      setTimeout(() => {
        instance.contactModalStatus = value;
      }, 50);
    }
  }

  async getSasSidebarCart() {
    if (this.sasSidebarCart) {
      this.sasSidebarCart.clear();
      const {SasSidebarCartComponent} = await import('../../sas-sidebar-cart/sas-sidebar-cart.component');
      const factory = this.cfr.resolveComponentFactory(SasSidebarCartComponent);
      this.sasSidebarCart.createComponent(factory, null, this.injector);
    }
  }

  async getProductNotAvailableSas() {
    if (this.sasProductNotAvailable) {
      this.sasProductNotAvailable.clear();
      const {SasProductNotAvailableComponent} = await import('../../../../modals/sas-product-not-available/sas-product-not-available.component');
      const factory = this.cfr.resolveComponentFactory(SasProductNotAvailableComponent);
      this.sasProductNotAvailable.createComponent(factory, null, this.injector);
    }
  }

  async getP2cHomebar() {
    if (this.p2cHomebar) {
      this.p2cHomebar.clear();
      const {P2cHomebarComponent} = await import('../../p2c-homebar/p2c-homebar.component');
      const factory = this.cfr.resolveComponentFactory(P2cHomebarComponent);
      this.p2cHomebar.createComponent(factory, null, this.injector);
    }
  }

  openAddEditAddressModal() {
    this.addressEvent.addAddressModalStatus.subscribe(event => {
      this.getAddEditAddressesModal(event);
    });
  }

  getRemoteConfig() {
    this.vm.getRemoteConfig().subscribe((config)=>{
      if (config.vipModalEnabled) {
        this.getCustomModal();
      }
    });
  }

  onSessionEvent() {

    this.sessionModalStatusEvent.updatedModalStatus
      .subscribe(event => {
        if (event && event.open) {
          this.openSessionModal();
        }
      });
  }

  notificationModalAfterLogin(){
    this.notificationModalEvent.updatedModalStatus
      .subscribe( notification =>{
        if (notification && notification.open) {
          setTimeout(()=>{
            this.openNotificationsModal();
          }, 500);
        }
      } );
  }

  scanAndGoListener() {
    this.scanAndGoStore = this.scanAndGoStore$
      .pipe(
        map(res => (res.config ? res.config : {})),
        distinctUntilKeyChanged('reload_cart'),
      )
      .subscribe(store => {
        if (store?.firebase?.reload_cart) {
          this.getAgile(true);
        }
      });
  }

  get bgColor(): string {
    if(!this.showBgImage && this.screenSize?.mobile) return this.colorNav;
    if(this.setHeaderStyle?.active && this.setHeaderStyle?.config?.header_primary_color) {
      return this.setHeaderStyle?.config?.header_primary_color;
    }
    return this.colorNav;
  }

  get bgImageUrl(): string {
    return this.showBgImage ? this.bgImage : '';
  }

  actionDyControlQuantity(id, fullPrice, mediaImageUrl, description, quantity) {
    if (Number(quantity) === 0) {
      this.vm.removeProduct(id).subscribe()
    } else {
      this.vm.addProduct(id, fullPrice, mediaImageUrl, description, quantity).subscribe();
    }
  }


  ngOnInit() {

    window['actionDyControlQuantity'] = this.actionDyControlQuantity.bind(this);

    this.vm.getPillReminderConfig();
    this.vm.getModifaceConfig();
    this.vm.getNavColorService().subscribe(res => {
      if (res) {
        if (res.headerColor !== '#fff') {
          this.logo = '/assets/svg/logo-farmatodo.svg';
          this.colorNav = res.headerColor;
          this.showBgImage = false;
        } else if (res.headerColor === '#fff') {
          this.logo = (!this.screenSize?.mobile) ? '/assets/svg/logo-farmatodo.svg' : '/assets/svg/logo-farmatodo-blue.svg';
          this.colorNav = (!this.screenSize?.mobile) ? '#418fde' : '#fff';
          this.showBgImage = true;
        }
      }
    });

    if (!this.isBrowser) {
      return;
    }
    this.eventPage.eventCallAllComponentsListener.subscribe( (res: any) => {
      if (res.allComponents) {
        this.callAllServices();
      }
    });

    this.loginEvent.hasCustomer.subscribe(() => {
      this.getAgile(true);
    });
  }

  openMicroChanges(){
    this.microChangesEvent.microChanges.subscribe(event => {
      this.getMicroCharges(event);
    });
  }

  listenPillReminderModals(){
    this.prModalsEvent.statusModals.subscribe(event => {
      if(event?.itemQuantityAlertModal) this.getItemQuantityAlert();
      if(event?.takePillModal) this.getTakePillModal();
      if(event?.popupModal) this.getPopupModal();
    });
  }

  callAllServices() {
    this.listenerRoutes();
    this.getAgile();
    this.performanceComponents = false;
    this.loadNavBar = true;

    this.loginEvent.listenerLoginModalStatus.subscribe((res: any) => {
      if(res.open) {
        this.getRegisterModal({open: true});
      }
    });

    if ( this.vm.getCustomer()?.customerId ) {
      this.customer = this.vm.getCustomer();
      this.createCreditCardModalEvent.updatedModalStatuscreditCard.subscribe( status =>{
        this.menuOptions(status);
      } );
      setTimeout( ()=> {
        this.getProfileMenu();
      }, 50)
    } else {
      this.loadNavBar = false;
    }

    timer(100)
      .pipe(first())
      .subscribe(() => {
        this.onAgileCartUpdated();
        this.onSasCartUpdated();
        this.onLogin();
        this.getAgileEvent();
        this.hasCustomer();
        this.onUpdateCustomer();
        this.onUpdateDeliveryType();
        this.onCartUpdated();
        this.onCallCenterLogin();
        this.onSessionEvent();
        setTimeout( () => {
          this.notificationModalAfterLogin();
        }, 300);
        this.scanAndGoListener();
        if (this.countryConfig.general.programAndSave) {
          this.getSasSidebarCart();
          this.getProductNotAvailableSas();
        }
        if (this.countryConfig.p2c) {
          setTimeout( () => {
            this.getP2cHomebar();
          }, 300);
        }
        this.loginEvent.closeSessionUser.subscribe(status => {
          if (status) {
            this.logOut();
          }
        });
        timer(5000).pipe(first()).subscribe(() => {
          this.loadModals = true;
          this.loadAddressesModal = true;
          setTimeout(() => {
            this.getCustomModal();
          }, 1);
        });
        timer(2500).pipe(first()).subscribe(() => {
          this.onLogin();
        });
        timer(2000).pipe(first()).subscribe(() => {
          this.loadMenu = true;
        });
        timer(1000).pipe(first()).subscribe(() => { this.loadOptions = true; });

        this.menuEvent.updatedOption
          .subscribe(option => {
            this.menuOptions(option);
          });

        this.addressEvent.updatedAddress
          .subscribe(address => {
            if (address) {
              this.getAddresses(true);
            }
          });

        this.addressEvent.getCustomerAddresses
          .subscribe(address => {
            if (address) {
              this.getAddresses(true);
            }
          });

        this.addressEvent.addressModalStatus
          .subscribe((status: any) => {
            if (status && status.open) {
              this.getAddressesModal({status: {open: true}, sasCart: this.sasCart, addresses: this.addresses});
            }
          });
        this.onEnableLifeMilesEvent();
        this.openAddEditAddressModal();
        this.openMicroChanges();
        this.listenPillReminderModals();
      });

    timer(5000).pipe(first()).subscribe(() => {
      this.loadModals = true;
      this.loadAddressesModal = true;
      setTimeout(() => {
        this.getCustomModal();
      }, 1);
    });
    timer(2500).pipe(first()).subscribe(() => {
      this.onLogin();
    });
    timer(2000).pipe(first()).subscribe(() => {
      this.loadMenu = true;
    });
    timer(1000).pipe(first()).subscribe(() => { this.loadOptions = true; });

    const isLifeMilesEnabled = this.vm.isLifeMilesEnabled();
    this.enableLifeMiles = typeof isLifeMilesEnabled === 'boolean' ? isLifeMilesEnabled : true;

    this.eventModalCreatePassword.updatedModalStatus.subscribe((res: any) => {
      if (res.open) {
        if (this.vm.codeChagePassword()) {
          this.getCreatePasswordModal({open: true});
        }
      }
    });

  }

  ngAfterContentInit(): void {

    this.showAppBar = window.location.pathname === '/';

    if (!this.isBrowser) {
      timer(200).pipe(first()).subscribe(() => {
        this.loadMenu = true;
      });
      return;
    }
    this.resizeEvent.currentScreenSize.subscribe(s => {
      if (s) {
        this.screenSize = s;
      }
    });

    timer(2000).pipe(first()).subscribe(() => { this.getRemoteConfig(); });
  }

  ngOnDestroy(): void {
    if (this.refChange) { this.dbRef.off('value', this.refChange); }
    window.removeEventListener('mouseover', this.callAllServices.bind(this), true);
  }

  ngAfterViewInit() {
    this.customer = this.vm.getCustomer();
    this.onCustomer();
  }

  listenerRoutes() {
    this.router.events.subscribe((events: any) => {
      if (events instanceof NavigationStart) {
        this.routerHome = events.url === '/' && this.countryConfig.navbar.routerHome;
      }
      if (events instanceof NavigationEnd) {
        this.gtmService.getPathTracker();
        document.getElementById('app-component-router-outlet').scrollTop = 0;
        if ( events.url === '/' ) {
          this.showAppBar = true;
          this.showSelectAddressEvent.set({show: true});
        } else {
          this.showAppBar = false;
          this.showSelectAddressEvent.set({show: false});
        }
        this.changeColorNavbarMobile(events.url);
      }
    });
  }

  getFavorites() {
    this.vm.getFavorites().subscribe(() => {});
  }

  changeColorNavbarMobile(routeCurrent) {
    if ( (routeCurrent.search('categorias') === -1 && !this.web) && (routeCurrent.search('departamentos?categoria=') !== 1 && !this.web)) {
      this.vm.setNavColorService('#fff');
    }
  }

  clearPrimeUser( item ){
    this.ssm.removeItem( item );
  }

  home(){
    this.updateNavbarEvent.updateColorNavbarHome( {toolbarBackground: '#418FDE'} );
    this.setColorHome = false;
  }

  validateOrders() {
    this.vm.getPreviousOrders().subscribe({
      next: orders => {
        const hasOrders = orders?.previousOrders?.length > 0;

        if (hasOrders) {
          const hasValidOrder = orders?.previousOrders.some(order => !(order.source === 'WEB' && order.deliveryType === 'SCANANDGO'));

          this.vm.setFirstPurchaseValidate(!hasValidOrder);
        } else {
          this.vm.setFirstPurchaseValidate(true);
        }
      },
      error: () => {
        this.vm.setFirstPurchaseValidate(false);
      },
    });
  }

  getAddressUser(): void {
    this.callGetAddress = false;

    this.vm.getAddress()
      .pipe(catchError(() => of([])))
      .subscribe(allAddressUser => {
        const addressDefault = allAddressUser?.filter(address => address?.defaultAddress)[0];

        if (addressDefault) {
          this.addressEvent.changeAddress(addressDefault);
          this.updateLocationEvent.changeAddress(addressDefault);
          this.vm.setAddressDefault(addressDefault);
        }
      });
  }
}

@NgModule({
  declarations: [NavbarComponent, DeliveryTypeComponent, AddressUserComponent, CartComponent, CountryComponent, NotificationIndicatorComponent],
  imports: [
    CommonModule,
    AlgoliaSearchBoxModule,
    AdvertisedProductsModule,
    LoadingModule,
    IconsModule,
    ButtonModule,
    CopCurrencyModule,
    MultiCountryCurrencyModule,
    RouterModule,
    DepartmentsHeaderModule,
    ImageTextSimpleModalModule,
    AddressSelectModule,
    HeaderModule
  ],
  exports: [NavbarComponent],
})
export class NavbarModule {}